import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { RouterModule } from '@angular/router';
import { UserMenuItem } from '@domain/models/auth/user-menu';
import { IconDirective } from '@view/shared/atoms/icons';

@Component({
  selector: 'app-sidebar-sub-item',
  standalone: true,
  imports: [CommonModule, RouterModule, IconDirective],
  animations: [
    trigger('anim', [
      state(
        'false',
        style({
          height: '0',
          padding: '0'
        })
      ),
      state(
        'true',
        style({
          height: '*'
        })
      ),
      transition('false => true', animate('250ms ease-in')),
      transition('true => false', animate('250ms ease-out'))
    ])
  ],
  template: `
    <ul class="rk-sidebar-submenu" [@anim]="visible">
      <li
        *ngFor="let menu of itemsMenu"
        class="rk-sidebar-item"
        [ngClass]="{ gt_sidebar_submeu_item: menu.active }"
        [ngStyle]="{ 'padding-left.px': paddingLeft }"
      >
        <a
          class="rk-sidebar-item-link pl-5"
          [routerLink]="
            menu.children && menu.children.length > 0
              ? null
              : '/'.concat(menu.contextPath)
          "
          (click)="toggleSubmenu(menu)"
        >
          <em
            appIcon
            [icon]="menu.image"
            class="mr-2"
            [ngClass]="{
              'rk-sidebar-icon--sub': paddingLeft > 20
            }"
          ></em>
          <span class="rk-text-submenu rk-headline--sub-one">{{
            menu.name
          }}</span>
        </a>
        <app-sidebar-sub-item
          *ngIf="menu.children && menu.children.length > 0"
          [basePath]="menu.contextPath"
          [visible]="menu.active"
          [itemsMenu]="menu.children"
          [paddingLeft]="paddingLeft + 1"
        ></app-sidebar-sub-item>
      </li>
    </ul>
  `,
  styles: []
})
export class SidebarSubItemComponent implements OnChanges {
  /**
   * items que deben ser renderizados
   */
  @Input()
  itemsMenu: Array<UserMenuItem> = [];
  /**
   * indica si se debe mostrar el submenu, esto ejecuta la animación
   */
  @Input()
  visible = false;
  /**
   * path del menu padre, este se usa para completar el enrutamiento
   */
  @Input() basePath = '';
  @Input() isExpanded!: boolean;
  /**
   * valor para aplicar un padding izquierdo a un subitem, valores validos:
   * 10: aplica padding-left 10
   * 20: aplica padding-left 20
   * 30: aplica padding-left 30
   * 40: aplica padding-left 40
   * 50: aplica padding-left 50
   */
  @Input() paddingLeft = 10;
  @Output() expanded = new EventEmitter<boolean>();
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isExpanded && changes.isExpanded.currentValue === false) {
      this.itemsMenu.forEach((item) => {
        item.active = false;
      });
    }
  }
  toggleSubmenu(menu: UserMenuItem): void {
    menu.active = !menu.active;
  }
}
